import { render, staticRenderFns } from "./quick-access-component.vue?vue&type=template&id=c58a1774"
import script from "./quick-access-component.vue?vue&type=script&lang=js"
export * from "./quick-access-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports